// extracted by css-extract-rspack-plugin
export default {"root":"ULM0dK","main-interface":"BQxRCE","mainInterface":"BQxRCE","space-for-cb":"di8d3G","spaceForCb":"di8d3G"};